<form #noteForm="ngForm" class="form-container">
  <div class="form-header">
    <div class="form-breadcrumb">
      <h3><a [routerLink]="['/note']">Note</a> > {{ note.voucher_number }}</h3>
    </div>
    <div class="form-actions">
      <a *ngIf="note.id && isFormDisabled && !['cancelled'].includes(note.status)" target="_blank" href="/api/note/{{ note.id }}/download">
        <button type="button" mat-stroked-button><mat-icon>print</mat-icon> Print</button>
      </a>
      <ng-container *ngIf="!['submitted','canceled'].includes(note.status)">
        <button *ngIf="isFormDisabled && note.status == 'draft'" type="button" mat-flat-button color="primary" (click)="confirmDialog(note.id, 'submit')">
          <mat-icon>check_circle</mat-icon> Submit
        </button>
        <button *ngIf="isFormDisabled && note.status == 'draft'" type="button" mat-stroked-button color="warn" (click)="confirmDialog(note.id, 'cancel')">Cancel</button>
        <button *ngIf="!isFormDisabled" [disabled]="onSaveDisable" type="submit" mat-flat-button color="primary" (click)="save(noteForm.valid)">
          <mat-icon>save</mat-icon> Save
        </button>
        <button *ngIf="isFormDisabled" type="button" mat-stroked-button (click)="edit()">
          <mat-icon>edit</mat-icon> Edit
        </button>
        <button *ngIf="!isFormDisabled" type="button" mat-stroked-button (click)="discardChanges()">Discard</button>
      </ng-container>
    </div>
  </div>
  <div class="form-card">
    <fieldset [disabled]="isFormDisabled">
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Voucher No.</mat-label>
            <input #voucher_number="ngModel" [disabled]="true" type="text" matInput name="voucher_number" [(ngModel)]="note.voucher_number" required>
            <mat-error *ngIf="voucher_number.invalid && voucher_number.touched">Required</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Voucher Date</mat-label>
            <input #date="ngModel" matInput [(ngModel)]="note.voucher_date" name="voucher_date" [matDatepicker]="voucher_date" [min]="minDate" [max]="maxDate" required>
            <mat-datepicker-toggle matSuffix [for]="voucher_date">
              <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #voucher_date></mat-datepicker>
            <mat-error *ngIf="date.invalid && date.touched">Required</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Note Type</mat-label>
            <mat-select [disabled]="isFormDisabled" [(value)]="selected_note_type" (selectionChange)="onAccountOrDoctorChange()">
              <input class="select-input" type="text" autocomplete="nope" matInput name="note_type">
              <mat-option *ngFor="let noteType of note_types" [value]="noteType">{{ noteType | titlecase }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Doctor</mat-label>
            <mat-select #doctor_id (openedChange)="onDoctorScroll($event)" [disabled]="isFormDisabled || disableDoctorSelection" [(value)]="selectedDoctor" (selectionChange)="onAccountOrDoctorChange()" required>
              <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keydown)="$event.stopPropagation()" (keyup)="onDoctorKey($event)" matInput name="doctort_list">
              <mat-option *ngFor="let doctor of allDoctors" [value]="doctor.id">{{ doctor.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Company</mat-label>
            <mat-select #company_id (openedChange)="OnCompanyScroll($event)" [disabled]="isFormDisabled || disableCompanySelection" [(value)]="selectedCompany" (selectionChange)="onCompanyChange()" required>
              <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keydown)="$event.stopPropagation()" (keyup)="OnCompanyKey($event)" matInput name="company_list">
              <mat-option *ngFor="let company of allCompanies" [value]="company.id">{{ company.company_name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Account</mat-label>
            <mat-select #account_id (openedChange)="onAccountScroll($event)" [disabled]="isFormDisabled || disableAccountSelection" [(value)]="selectedAccount" (selectionChange)="onAccountOrDoctorChange()" required>
              <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keydown)="$event.stopPropagation()" (keyup)="onAccountKey($event)" matInput name="account_list">
              <mat-option *ngFor="let account of allAccounts" [value]="account.id">{{ account.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Narration</mat-label>
            <textarea #narration="ngModel" matInput name="narration" [(ngModel)]="note.narration"></textarea>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <div class="field-label">Balance</div>
          <p class="note-balance">{{ note.balance }}</p>
        </div>
      </div>

      <!-- Tax Totals -->
      <div class="row pt-4">
        <div class="col-sm-6"></div>
        <div class="col-sm-6">
          <div class="totals-card">
            <div class="totals-row">
              <span>Amount (&#8377;):</span>
              <span><input class="totals-input" required [(ngModel)]="note.amount" name="amount" type="number" (focusout)="calculateNoteTaxes(note)"></span>
            </div>
            <div class="totals-row"><span>SGST (&#8377;):</span><span>{{ note.sgst_amount | currency :'INR':'symbol':'1.2-2' }}</span></div>
            <div class="totals-row"><span>CGST (&#8377;):</span><span>{{ note.cgst_amount | currency :'INR':'symbol':'1.2-2' }}</span></div>
            <div class="totals-row"><span>IGST (&#8377;):</span><span>{{ note.igst_amount | currency :'INR':'symbol':'1.2-2' }}</span></div>
            <div class="totals-row totals-grand"><span>Grand Total (&#8377;):</span><span>{{ note.grand_total | currency :'INR':'symbol':'1.2-2' }}</span></div>
          </div>
        </div>
      </div>

      <!-- Knock-Off Tab -->
      <mat-tab-group animationDuration="0ms" class="mt-4">
        <mat-tab id="knock_off_list" label="Knock-Off">
          <table mat-table [dataSource]="knockoffsDataSource" #knock_off_lines class="mat-elevation-z2 mt-3">
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef>Select</th>
              <td mat-cell *matCellDef="let row">
                <mat-checkbox color="primary" (click)="$event.stopPropagation()" (change)="toggleSelection(row)" [checked]="selection.isSelected(row)" [disabled]="isFormDisabled || (note.balance <= 0 && !selection.isSelected(row))"></mat-checkbox>
              </td>
            </ng-container>
            <ng-container class="mat-table-row" [matColumnDef]="column" *ngFor="let column of displayColumns; let i = index;">
              <th class="font-weight-bold" mat-header-cell *matHeaderCellDef>{{ displayHeaders[i] }}</th>
              <td mat-cell *matCellDef="let obj" class="header-cell">{{ obj[column] }}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayColumnsWithSelect"></tr>
            <tr mat-row *matRowDef="let row; columns: displayColumnsWithSelect;"></tr>
          </table>
        </mat-tab>
      </mat-tab-group>
    </fieldset>
  </div>
  <app-audit-log-viewer model="note" [recordId]="note.id"></app-audit-log-viewer>
</form>
